import React from 'react'
import HeaderComponent from './HeaderComponent'
import hackathon from '../assets/hackathon.png'
import { Link } from 'react-router-dom'
import PreviousEventSection from './PreviousEventSection'


const Hackathon = () => {
    const image = {hackathon}
  return (
    <>
        <HeaderComponent/>
        <div className='items-center text-center mt-8 mb-58'>
            <h1 className='text-4xl font-bold mb-6'>Hackathon/CTF</h1>
            <img src={hackathon} className='w-full mx-auto'/>
            <p className='text-3xl text-primary mt-6 mb-28'>Welcome to the TECHX Africa CTF Guide</p>
           <div className='mb-28'><Link className='bg-[#F63A0A] px-6 py-3 text-white'>Apply Here</Link></div>
        </div>
      <PreviousEventSection/>
    </>
  )
}

export default Hackathon